function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M39.5 28.388H24.63a.5.5 0 00-.415.221l-1.025 1.52h-6.38l-1.025-1.52a.501.501 0 00-.415-.22H.501a.5.5 0 00-.5.5v2.307a3.297 3.297 0 003.431 3.135H36.57A3.297 3.297 0 0040 31.196v-2.308a.502.502 0 00-.5-.5zm-.5 2.808a2.3 2.3 0 01-2.431 2.135H3.432a2.299 2.299 0 01-2.43-2.135V29.39h14.103l1.024 1.52a.5.5 0 00.416.222h6.912a.5.5 0 00.415-.222l1.025-1.52H39v1.807zM2.372 27.585a.5.5 0 00.5-.5V6.845a.673.673 0 01.672-.672h32.912a.673.673 0 01.672.672v20.24a.5.5 0 001.001 0V6.845a1.674 1.674 0 00-1.673-1.673H3.544a1.674 1.674 0 00-1.672 1.673v20.24a.5.5 0 00.5.5z",
  fill: "#696969"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.23 18.203H8.628a.5.5 0 00-.5.5v6.603a.5.5 0 00.5.5h6.602a.5.5 0 00.5-.5v-6.603a.5.5 0 00-.5-.5zm-.5 6.603h-5.6v-5.6h5.6v5.6zM15.73 12.788a.5.5 0 00-1 0v2.458h-5.6v-5.6h4.51a.5.5 0 000-1H8.63a.5.5 0 00-.502.5v6.602a.5.5 0 00.501.5h6.603a.5.5 0 00.5-.5l-.002-2.96z",
  fill: "#696969"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.087 9.187a.5.5 0 00-.708 0l-3.366 3.367-1.078-1.078a.5.5 0 00-.708.708l1.432 1.431a.5.5 0 00.708 0l3.72-3.72a.5.5 0 000-.708zM31.622 10.304H19.853a.5.5 0 000 1h11.769a.5.5 0 100-1zM19.855 14.587h7.527a.5.5 0 000-1h-7.527a.5.5 0 100 1zM32.125 20.36a.5.5 0 00-.5-.5H19.856a.502.502 0 000 1h11.766a.5.5 0 00.503-.5zM19.855 23.143a.5.5 0 100 1h7.527a.5.5 0 000-1h-7.527z",
  fill: "#696969"
});

var SvgIconBasicInfo = function SvgIconBasicInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgIconBasicInfo;